export default __webpack_public_path__ + "i18n/translations/translation-ml.bb70cb01.json";